export default __webpack_public_path__ + "static/media/island_6.489f1145.png";